<!-- 编辑框 -->
<template>
    <el-dialog :title="title" :visible.sync="visible" width="50%" :append-to-body="true" :before-close="handleCloseDialog">

        <el-form :model="deviceForm" label-width="120px">
            <el-form-item label="集控器">
                <el-select v-model="deviceForm.collector_id" style="width:100%;" filterable placeholder="请选择" @change="changeCollector">
                    <el-option
                        v-for="item in collectorList"
                        :key="item.oid"
                        :label="item.dev_name +' : ' + item.dev_serial"
                        :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="PLC">
                <el-select v-model="deviceForm.plc_id" style="width:100%;" filterable placeholder="请选择" @change="changePlc">
                    <el-option
                        v-for="item in plcList"
                        :key="item.oid"
                        :label="item.customized_serial + ' : ' + item.terminal_serial"
                        :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="绑定地址" key="device_info">
                <el-select v-model="deviceForm.device_info" style="width:100%;" filterable placeholder="请选择">
                    <el-option
                        v-for="item in varData"
                        :key="item.value"
                        :label="item.var_name+' : '+item.var_Initial_addr"
                        :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="相关参数" key="otherAddr">
                <el-select v-model="deviceForm.other_info" style="width:100%;" filterable multiple placeholder="请选择">
                    <el-option
                        v-for="item in varData"
                        :key="item.value"
                        :label="item.var_name+' : '+item.var_Initial_addr"
                        :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="按钮参数">
                <el-select v-model="deviceForm.opt_info" style="width:100%;" filterable placeholder="请选择">
                    <el-option
                        v-for="item in varData"
                        :key="item.value"
                        :label="item.var_name+' : '+item.var_Initial_addr"
                        :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="启动值" >
                <el-input v-model="deviceForm.startVal" autocomplete="off"></el-input>
            </el-form-item>
             <el-form-item label="停止值">
                <el-input v-model="deviceForm.stopVal" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'

const Params = {
    collector_id: '',
    plc_id: '',
    device_info: '',
    other_info: [],
    opt_info: '',
    startVal: 1,
    stopVal: 0,
}

export default {
    name: 'cmpBindaddrDialog',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        form: {
            type: Object,
            default: {}
        }
    },
    data () {
        return {
            dialogFormVisible: false,
            deviceForm: JSON.parse(JSON.stringify(Params)),
            
        };
    },

    watch: {
        visible(newVal) {
            if(newVal) {
                this.handleInitData(this.form);
            }
        }
    },

    computed: {
        ...mapGetters(["machine"]),
        title() {
            return '设置addr';
        },
        collectorList() {
            return this.machine.collect
        },
        plcList() {
            return this.machine.devices
        },
        varData() {
            return this.machine.var_config
        }
    },

    mounted() {
        this.getList()
    },

    methods: {
        async handleInitData(Val) {
            if(JSON.stringify(Val) === "{}") return;
            if(Val.dataset.params !== undefined) {
                // 编辑
                let params = JSON.parse(Val.dataset.params)
                await this.getDeviceList(params.collector_id);
                await this.getPlcConfig(params.plc_id);
                this.deviceForm = params;
            }else{
                // 新增
                this.deviceForm = JSON.parse(JSON.stringify(Params));
            }
        },
        // 获取集控器列表
        async getList() {
            if(this.machine.collect.length>0) {
                return
            }
            let data = await Service.getCollector();
            if(data){
                data = data === 'success' ? [] : data;
                if(data.length>0){
                    this.$store.dispatch('setCollect', data);
                }
            }
        },
        // 获取表计
        async getDeviceList(collectId) {
            let params = Object.assign({}, { page_num: 1, page_sum: 1000, }, {OID: collectId});
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                // if(list.length>0) {
                    this.deviceForm.plc_id = '';
                   
                    this.$store.dispatch('setDevices', list);
                // } 
            }
        },
        // 获取变量列表
        async getPlcConfig(terminal_id) {
            
            if(terminal_id === '') 
            {
                let list = []
                this.$store.dispatch('setVarConfig', list);
                return
            }
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 1000,
            }
            
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.$store.dispatch('setVarConfig', list);

                this.deviceForm.device_info = ''
                this.deviceForm.other_info= []
                this.deviceForm.opt_info= ''
            }
        },
        changeCollector(val) {
            this.getDeviceList(val)
        },
        changePlc(val) {
            this.getPlcConfig(val);
        },
        // 关闭弹框
        handleCloseDialog() {
            this.$emit("handleCloseDialog", {flag: false});
        },
        // 确认关闭
        handleSave() {
            this.$emit("handleCloseDialog", {flag: true, data: this.deviceForm});
        },
    }
}

</script>
<style lang='less' scoped>
.chose-addr{
    width: 150px;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #606266;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    box-sizing: border-box;
    cursor: pointer;
}
</style>